// extracted by mini-css-extract-plugin
export default {"root":"Register-root--o9T7J"};